var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Box, Grid, IconButton, Paper, Skeleton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField as MuiTextField, Typography, } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import moment from 'moment';
import AutoCompleteDD from '../../../components/FormComponents/AutoCompleteDD';
import CustomButton from '../../../components/buttonComponent/CustomButton';
import constants from '../../../config/constants';
import { TAKEDOWN_STATUS, } from '../../../interfaces/createApplication';
import { utility } from '../../../utils';
import CreateTakedownDialog from './CreateTakedownDialog';
import { formatCurrencyDisplay } from '../config/form_field_factories';
import { fetchLocApplications, fetchTakedownPrograms, } from '../schedule_takedown_service';
import { EMPTY_STATE_CARD_SX, EMPTY_STATE_ICON_SX, INFO_BANNER_ICON_SX, INFO_BANNER_SX, LOC_CARD_SX, LOC_ROW_HEADER_SX, LOC_ROW_VALUE_SX, SEARCH_CARD_SX, STATUS_COLOR_BY_LOC_STATUS, TAKEDOWN_SURFACE_SX, TAKEDOWN_TABLE_BODY_ROW_SX, TAKEDOWN_TABLE_HEAD_ROW_SX, } from './ScheduleTakedownStyles';
var REQUIRED_FIELD_MESSAGE = 'This field is required';
var NO_RECORDS_MESSAGE = 'No records found';
var ZERO_BALANCE_MESSAGE = "You don't have balance to file a takedown";
var LOC_EXPIRED_MESSAGE = 'Selected LOC is Expired.';
var DATE_FORMAT = 'MM/DD/YYYY';
var TAKEDOWN_DATE_FORMAT = 'MM/DD/YYYY | hh:mm A';
var SKELETON_ROW_COUNT = 4;
var PER_PAGE_COUNT = 5;
var TAKEDOWN_STATUS_LABELS = {
    Approved: 'Approved',
    Credit: 'Credit',
    Documents: 'Documents',
    Booked: 'Booked',
    'Credit More Info': 'More Info Requested',
};
var formatDate = function (value, format) {
    if (!value) {
        return '--';
    }
    var parsed = moment(value).utcOffset(0);
    return parsed.isValid() ? parsed.format(format) : '--';
};
var formatAmount = function (amount) {
    return Number.isFinite(amount) && amount !== 0 ? formatCurrencyDisplay(amount) : '--';
};
var LocRowItem = function (_a) {
    var label = _a.label, children = _a.children;
    return (React.createElement(Stack, null,
        React.createElement(Typography, { sx: LOC_ROW_HEADER_SX }, label),
        children));
};
var ScheduleTakedownLocList = function (_a) {
    var _b;
    var _c = _a.initialProgramAspireOId, initialProgramAspireOId = _c === void 0 ? '' : _c, raisedFor = _a.raisedFor, onSelectLoc = _a.onSelectLoc;
    var _d = React.useState([]), programOptions = _d[0], setProgramOptions = _d[1];
    var _e = React.useState(initialProgramAspireOId), programAspireOId = _e[0], setProgramAspireOId = _e[1];
    var _f = React.useState(''), programError = _f[0], setProgramError = _f[1];
    var _g = React.useState(''), customerTaxId = _g[0], setCustomerTaxId = _g[1];
    var _h = React.useState(''), customerTaxIdError = _h[0], setCustomerTaxIdError = _h[1];
    var _j = React.useState(null), isFetching = _j[0], setIsFetching = _j[1];
    var _k = React.useState([]), locApplications = _k[0], setLocApplications = _k[1];
    var _l = React.useState(new Set()), openAccordionKeys = _l[0], setOpenAccordionKeys = _l[1];
    var _m = React.useState(1), currentPage = _m[0], setCurrentPage = _m[1];
    var _o = React.useState(null), confirmingLoc = _o[0], setConfirmingLoc = _o[1];
    React.useEffect(function () {
        var isCancelled = false;
        fetchTakedownPrograms().then(function (_a) {
            var options = _a.options, errorMessage = _a.errorMessage;
            if (isCancelled) {
                return;
            }
            setProgramOptions(options);
            if (errorMessage) {
                utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
            }
        });
        return function () {
            isCancelled = true;
        };
    }, []);
    var handleProgramChange = React.useCallback(function (event) {
        setProgramAspireOId(event.target.value);
        setProgramError('');
    }, []);
    var handleTaxIdChange = React.useCallback(function (event) {
        setCustomerTaxId(event.target.value.trim());
        setCustomerTaxIdError('');
    }, []);
    var handleSearch = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var nextProgramError, nextTaxIdError, _a, rows, errorMessage;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    nextProgramError = programAspireOId ? '' : REQUIRED_FIELD_MESSAGE;
                    nextTaxIdError = customerTaxId ? '' : REQUIRED_FIELD_MESSAGE;
                    setProgramError(nextProgramError);
                    setCustomerTaxIdError(nextTaxIdError);
                    if (nextProgramError || nextTaxIdError) {
                        return [2];
                    }
                    setIsFetching(true);
                    setLocApplications([]);
                    return [4, fetchLocApplications(programAspireOId, customerTaxId)];
                case 1:
                    _a = _b.sent(), rows = _a.locApplications, errorMessage = _a.errorMessage;
                    setIsFetching(false);
                    setCurrentPage(1);
                    if (errorMessage) {
                        setCustomerTaxIdError(errorMessage);
                        return [2];
                    }
                    setLocApplications(rows);
                    setOpenAccordionKeys(new Set(rows.map(function (row) { return row.transactionNum; })));
                    return [2];
            }
        });
    }); }, [customerTaxId, programAspireOId]);
    var toggleAccordion = React.useCallback(function (transactionNum) {
        setOpenAccordionKeys(function (previousKeys) {
            var nextKeys = new Set(previousKeys);
            if (nextKeys.has(transactionNum)) {
                nextKeys.delete(transactionNum);
            }
            else {
                nextKeys.add(transactionNum);
            }
            return nextKeys;
        });
    }, []);
    var selectedProgram = React.useMemo(function () { var _a; return (_a = programOptions.find(function (option) { return option.value === programAspireOId; })) !== null && _a !== void 0 ? _a : null; }, [programAspireOId, programOptions]);
    var handleSelectLoc = React.useCallback(function (locApplication) {
        if (locApplication.availableAmount <= 0) {
            utility.alert(ZERO_BALANCE_MESSAGE, constants.TOAST_TYPES.WARN);
            return;
        }
        if (locApplication.status !== TAKEDOWN_STATUS.Active) {
            utility.alert(LOC_EXPIRED_MESSAGE, constants.TOAST_TYPES.WARN);
            return;
        }
        setConfirmingLoc(locApplication);
    }, []);
    var closeTakedownDialog = React.useCallback(function () { return setConfirmingLoc(null); }, []);
    var handleTakedownProceed = React.useCallback(function (raisedFor) {
        var _a, _b;
        if (!confirmingLoc) {
            return;
        }
        setConfirmingLoc(null);
        onSelectLoc(confirmingLoc, __assign({ programAspireOId: programAspireOId, programId: (_a = selectedProgram === null || selectedProgram === void 0 ? void 0 : selectedProgram.programId) !== null && _a !== void 0 ? _a : '', programName: String((_b = selectedProgram === null || selectedProgram === void 0 ? void 0 : selectedProgram.label) !== null && _b !== void 0 ? _b : ''), customerTaxId: customerTaxId }, raisedFor));
    }, [confirmingLoc, customerTaxId, onSelectLoc, programAspireOId, selectedProgram]);
    var totalPages = Math.ceil(locApplications.length / PER_PAGE_COUNT) || 1;
    var visibleLocApplications = React.useMemo(function () {
        var firstIndex = (currentPage - 1) * PER_PAGE_COUNT;
        return locApplications.slice(firstIndex, firstIndex + PER_PAGE_COUNT);
    }, [currentPage, locApplications]);
    var isBeforeFirstSearch = isFetching === null;
    return (React.createElement(Box, null,
        React.createElement(Typography, { fontSize: "16px", fontWeight: 500, pb: 2 }, "LOC/DORF Take Down"),
        React.createElement(Box, { sx: TAKEDOWN_SURFACE_SX },
            React.createElement(Box, { sx: SEARCH_CARD_SX },
                React.createElement(Typography, { fontSize: "15px", fontWeight: 600, mb: 2.5 }, "Request a Take Down on a LOC/DORF"),
                React.createElement(Grid, { container: true, spacing: 2, alignItems: "flex-start" },
                    React.createElement(Grid, { item: true, xs: 12, sm: 5, md: 5 },
                        React.createElement(Typography, { fontSize: "13px", fontWeight: 500, mb: 0.5 },
                            "Program Name\u00A0",
                            React.createElement(Box, { component: "span", color: "#D84315" }, "*")),
                        React.createElement(AutoCompleteDD, { options: programOptions, displayKey: "label", valueKey: "value", label: "", placeholder: "Select Program", name: "programAspireOId", selectedValue: (_b = programOptions.find(function (option) { return option.value === programAspireOId; })) !== null && _b !== void 0 ? _b : null, handleChange: handleProgramChange, handleBlur: function () { return undefined; }, errorMessage: programError })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 5, md: 5 },
                        React.createElement(Typography, { fontSize: "13px", fontWeight: 500, mb: 0.5 },
                            "Enter Customer's Tax ID\u00A0",
                            React.createElement(Box, { component: "span", color: "#D84315" }, "*")),
                        React.createElement(MuiTextField, { fullWidth: true, size: "small", name: "customerTaxId", value: customerTaxId, onChange: handleTaxIdChange, error: Boolean(customerTaxIdError), helperText: customerTaxIdError, inputProps: { maxLength: 15, autoComplete: 'off' } })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 2, md: 2 },
                        React.createElement(Typography, { fontSize: "13px", mb: 0.5, sx: { visibility: 'hidden' }, "aria-hidden": true }, "\u00A0"),
                        React.createElement(CustomButton, { fullWidth: false, onClick: handleSearch, disabled: isFetching === true, sx: { height: 38, maxWidth: 100, whiteSpace: 'nowrap' } }, "Search")))),
            isBeforeFirstSearch && (React.createElement(React.Fragment, null,
                React.createElement(Box, { sx: INFO_BANNER_SX },
                    React.createElement(Box, { sx: INFO_BANNER_ICON_SX },
                        React.createElement(InfoOutlinedIcon, { sx: { fontSize: 16, color: '#fff' } })),
                    React.createElement(Typography, { fontSize: "13px", color: "#1E3A5F" }, "Enter the customer's tax ID above and click Search to fetch the available line of credit and take down details.")),
                React.createElement(Box, { sx: EMPTY_STATE_CARD_SX },
                    React.createElement(Stack, { alignItems: "center", spacing: 2 },
                        React.createElement(Box, { sx: EMPTY_STATE_ICON_SX },
                            React.createElement(DescriptionOutlinedIcon, { sx: { fontSize: 48, color: '#6B7280' } })),
                        React.createElement(Typography, { fontSize: "14px", color: "text.secondary", textAlign: "center", maxWidth: 280 }, "Your LOC/DORF takedown details will appear here."))))),
            isFetching === true &&
                Array.from({ length: SKELETON_ROW_COUNT }).map(function (_row, skeletonIndex) { return (React.createElement(Box, { key: "loc-skeleton-".concat(skeletonIndex), sx: LOC_CARD_SX },
                    React.createElement(Grid, { container: true, spacing: 2, sx: { p: '15px 20px' } }, Array.from({ length: 6 }).map(function (_cell, cellIndex) { return (React.createElement(Grid, { item: true, xs: 2, key: "loc-skeleton-cell-".concat(cellIndex) },
                        React.createElement(Skeleton, { variant: "text", width: 80 }),
                        React.createElement(Skeleton, { variant: "text", width: 100 }))); })))); }),
            isFetching === false && locApplications.length === 0 && (React.createElement(Stack, { justifyContent: "center", alignItems: "center", height: 150 },
                React.createElement(Typography, { fontSize: "16px" }, NO_RECORDS_MESSAGE))),
            visibleLocApplications.map(function (locApplication) {
                var _a;
                var isOpen = openAccordionKeys.has(locApplication.transactionNum);
                return (React.createElement(Box, { key: locApplication.transactionNum, sx: LOC_CARD_SX },
                    React.createElement(Grid, { container: true, spacing: 2, alignItems: "center", sx: { p: '15px 20px' } },
                        React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 2 },
                            React.createElement(LocRowItem, { label: "Customer Name" },
                                React.createElement(Typography, { sx: LOC_ROW_VALUE_SX }, locApplication.customerName || '--'))),
                        React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 2 },
                            React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 0.5 },
                                React.createElement(LocRowItem, { label: "Transaction Number" },
                                    React.createElement(Typography, { sx: LOC_ROW_VALUE_SX }, locApplication.transactionNum || '--')),
                                React.createElement(IconButton, { size: "small", sx: { p: 0.5 }, "aria-label": "".concat(isOpen ? 'Hide' : 'Show', " takedowns for ").concat(locApplication.transactionNum), onClick: function () {
                                        return toggleAccordion(locApplication.transactionNum);
                                    } }, isOpen ? (React.createElement(ArrowDropUpIcon, { sx: { fontSize: 20 } })) : (React.createElement(ArrowDropDownIcon, { sx: { fontSize: 20 } }))))),
                        React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 2 },
                            React.createElement(LocRowItem, { label: "Approved Amount" },
                                React.createElement(Typography, { sx: LOC_ROW_VALUE_SX }, formatAmount(locApplication.approvedAmount)))),
                        React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 2 },
                            React.createElement(LocRowItem, { label: "Available Amount" },
                                React.createElement(Typography, { sx: LOC_ROW_VALUE_SX }, formatAmount(locApplication.availableAmount)))),
                        React.createElement(Grid, { item: true, xs: 6, sm: 3, md: 1 },
                            React.createElement(LocRowItem, { label: "Expiration Date" },
                                React.createElement(Typography, { sx: LOC_ROW_VALUE_SX }, formatDate(locApplication.expirationDate, DATE_FORMAT)))),
                        React.createElement(Grid, { item: true, xs: 6, sm: 3, md: 1 },
                            React.createElement(LocRowItem, { label: "Status" },
                                React.createElement(Typography, { sx: __assign(__assign({}, LOC_ROW_VALUE_SX), { color: (_a = STATUS_COLOR_BY_LOC_STATUS[locApplication.status]) !== null && _a !== void 0 ? _a : 'inherit' }) }, locApplication.status || '--'))),
                        React.createElement(Grid, { item: true, xs: 12, md: 2, sx: { display: 'flex', justifyContent: 'flex-end' } },
                            React.createElement(CustomButton, { variant: "outlined", SMButton: true, fullWidth: false, endIcon: locApplication.isDraft ? undefined : (React.createElement(ArrowForwardIcon, { sx: { fontSize: 18 } })), onClick: function () { return handleSelectLoc(locApplication); }, sx: { whiteSpace: 'nowrap' } }, locApplication.isDraft
                                ? 'Saved Application'
                                : 'Create Takedown'))),
                    isOpen && (React.createElement(TableContainer, { component: Paper, sx: { boxShadow: 'none', borderTop: '1px solid #E5E7EB' } },
                        React.createElement(Table, { sx: { minWidth: 650 }, "aria-label": "Take downs" },
                            React.createElement(TableHead, null,
                                React.createElement(TableRow, { sx: TAKEDOWN_TABLE_HEAD_ROW_SX },
                                    React.createElement(TableCell, null, "Take Downs"),
                                    React.createElement(TableCell, null, "Amount Financed"),
                                    React.createElement(TableCell, null, "Date"),
                                    React.createElement(TableCell, null, "Status"))),
                            React.createElement(TableBody, null, locApplication.takedowns.length ? (locApplication.takedowns.map(function (takedown, takedownIndex) {
                                var _a;
                                return (React.createElement(TableRow, { key: takedown.transactionNum, sx: TAKEDOWN_TABLE_BODY_ROW_SX },
                                    React.createElement(TableCell, null,
                                        React.createElement(Typography, { fontSize: "12px", color: "text.secondary" }, "Take Down ".concat(takedownIndex + 1)),
                                        React.createElement(Typography, { fontSize: "14px", fontWeight: 600, mt: 0.25 }, takedown.transactionNum ||
                                            '--')),
                                    React.createElement(TableCell, null,
                                        React.createElement(Typography, { fontSize: "14px" }, formatAmount(takedown.amountRequested))),
                                    React.createElement(TableCell, null,
                                        React.createElement(Typography, { fontSize: "14px" }, formatDate(takedown.createdDate, TAKEDOWN_DATE_FORMAT))),
                                    React.createElement(TableCell, null,
                                        React.createElement(Typography, { fontSize: "14px", fontWeight: 600, color: "primary" }, (_a = TAKEDOWN_STATUS_LABELS[takedown.status]) !== null && _a !== void 0 ? _a : (takedown.status || '--')))));
                            })) : (React.createElement(TableRow, null,
                                React.createElement(TableCell, { colSpan: 4 },
                                    React.createElement(Typography, { textAlign: "center", fontSize: "14px", fontWeight: 600 }, NO_RECORDS_MESSAGE))))))))));
            }),
            locApplications.length > PER_PAGE_COUNT && (React.createElement(Stack, { direction: "row", justifyContent: "center", alignItems: "center", spacing: 2, py: 1 },
                React.createElement(CustomButton, { variant: "secondary", SMButton: true, fullWidth: false, disabled: currentPage === 1, onClick: function () { return setCurrentPage(function (page) { return Math.max(1, page - 1); }); } }, "Previous"),
                React.createElement(Typography, { fontSize: "13px" }, "Page ".concat(currentPage, " of ").concat(totalPages)),
                React.createElement(CustomButton, { variant: "secondary", SMButton: true, fullWidth: false, disabled: currentPage >= totalPages, onClick: function () {
                        return setCurrentPage(function (page) { return Math.min(totalPages, page + 1); });
                    } }, "Next")))),
        React.createElement(CreateTakedownDialog, { open: Boolean(confirmingLoc), locApplication: confirmingLoc, program: selectedProgram, raisedFor: raisedFor, onClose: closeTakedownDialog, onProceed: handleTakedownProceed })));
};
export default ScheduleTakedownLocList;
